<template>
  <div class="bg-[#0F172B]">
    <EffectPickerPanel
      :initial-effect-type="initialEffectType"
      :get-effect-href="
        (effect) => `/ai/effects/${effect.effect_type}/${effect.code}/`
      "
      :is-dev="isDev"
      @type-change="handleEffectTypeChange"
      @select="useTemplate"
    />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import EffectPickerPanel from "@/components/ai-effects/EffectPickerPanel.vue";

definePageMeta({ layout: "default-new" });

const store = useStore();
const isDev = computed(() => store.state.user.is_dev);

const route = useRoute();
const router = useRouter();

function normalizeEffectType(type) {
  return type === "image" || type === "video" ? type : "video";
}

const initialEffectType = computed(() => {
  const queryType = Array.isArray(route.query.type)
    ? route.query.type[0]
    : route.query.type;
  return normalizeEffectType(queryType);
});

const useTemplate = (effect) => {
  router.push(`/ai/effects/${effect.effect_type}/${effect.code}/`);
};

const handleEffectTypeChange = (type) => {
  const nextType = normalizeEffectType(type);
  if (initialEffectType.value === nextType) return;
  router.replace({
    path: route.path,
    query: {
      ...route.query,
      type: nextType,
    },
  });
};

const title =
  "AI Photo & Video Effects - One-Click AI Filters & Styles | SharkFoto";
const description =
  "Instantly apply amazing AI effects to your images and videos. Choose from hundreds of one-click filters and styles to create unique visuals effortlessly on SharkFoto.";
const cdnUrl = useRuntimeConfig().public.cdnUrl;
useSeoMeta({
  title,
  description,
  canonical: "https://sharkfoto.com/ai/effects/",
  ogTitle: title,
  ogDescription: description,
  ogImage: `${cdnUrl}/sharkfoto_og.png`,
  ogUrl: "https://sharkfoto.com/ai/effects/",
  ogSiteName: "SharkFoto",
  ogType: "website",
  ogLocale: "en_US",
  twitterCard: "summary_large_image",
  twitterUrl: "https://sharkfoto.com/ai/effects/",
  twitterTitle: title,
  twitterDescription: description,
  twitterImage: `${cdnUrl}/sharkfoto_og.png`,
  twitterSite: "@Shark_Foto",
  twitterCreator: "@Shark_Foto",
});
</script>
